import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@bufferapp/ui';
import { getLargeSafeImageUrl } from '~/story-group-composer/utils/SafeImage';
import NoteSection from '../NoteSection';

const FooterBar = styled.div`
  padding: 13px 0px 0px;
  display: flex;
`;

const ContentWrapper = styled.div`
  display: flex;
`;

const ButtonStyle = styled.div`
  margin-left: auto;
  margin-right: 5px;
`;

const StyledImage = styled.img`
  object-fit: cover;
`;

const AddNote = ({ onSaveNoteClick, onCancelClick, story }) => {
  const [note, setNote] = useState(story ? story.note : null);
  const translations = useSelector(
    (state) => state.i18n.translations['story-group-composer']
  );
  const setNoteValue = (event) => {
    const { value } = event.target;
    setNote(value);
  };

  return (
    <>
      <ContentWrapper>
        <div>
          <StyledImage
            src={getLargeSafeImageUrl(story.thumbnail_url)}
            alt={translations.noteImageAlt}
            height="320px"
            width="180px"
          />
        </div>
        <NoteSection
          note={note}
          setNote={setNoteValue}
          translations={translations}
        />
      </ContentWrapper>
      <FooterBar>
        <ButtonStyle>
          <Button
            type="text"
            label={translations.cancelNoteButton}
            onClick={onCancelClick}
          />
        </ButtonStyle>
        <Button
          type="primary"
          label={translations.saveNoteButton}
          onClick={() => onSaveNoteClick({ order: story.order, note })}
        />
      </FooterBar>
    </>
  );
};

AddNote.propTypes = {
  onSaveNoteClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  story: PropTypes.shape({
    thumbnail_url: PropTypes.string,
    note: PropTypes.string,
    order: PropTypes.number,
    type: PropTypes.oneOf(['image', 'video', 'gif']),
  }).isRequired,
};

export default AddNote;
